<div class="login-container">
  <div class="d-flex flex-column align-items-center">
    <div class="d-flex flex-column mt-5 mb-4">
      <span class="welcome mb-3 m-auto">Welcome to DPNF</span>
      <span class="diksha-patra">Sign in with Dikshapatra works</span>
    </div>

    <div class="d-flex flex-column login-card">
      <form [formGroup]="loginForm" (ngSubmit)="login()">
        <div class="d-flex flex-column mb-3">
          <label class="login-label">Email address</label>
          <input type="email" formControlName="email" class="login-field mt-1" placeholder="Enter your email address" />
          <span class="text-danger" *ngIf="
							loginForm.controls['email'].invalid &&
							loginForm.controls['email'].touched
						">
            Please provide a valid email address
          </span>
        </div>
        <div class="d-flex flex-column password-group">
          <label class="login-label">Password</label>
          <i class="fa fa-eye icon" (click)="onEyeOpen()" *ngIf="eyeOpen"></i>
          <i class="fa fa-eye-slash icon" (click)="onEyeClose()" *ngIf="!eyeOpen"></i>
          <input [type]="type" formControlName="password" class="login-field mt-1" placeholder="Enter your password" />
          <span class="text-danger" *ngIf="
							loginForm.controls['password'].invalid &&
							loginForm.controls['password'].touched
						">
            Password is required
          </span>
        </div>
        <div class="text-center text-danger mt-3" *ngIf="loginErrorMessage">
          {{ loginErrorMessage }}
        </div>
        <button class="login-button mt-3 mb-4" [disabled]="loginForm.invalid" *ngIf="loginForm.invalid">
          Enter your details to proceed
        </button>
        <button class="signin-button mt-3 mb-4" type="submit" *ngIf="loginForm.valid">
          Login
          <i *ngIf="submitting" class="fas fa-spinner fa-spin ms-1"></i>
        </button>
      </form>

      <div class="text-center">
        <span class="account-text">Don’t have an account? Contact Admin</span>

        <!-- <a routerLink="/signup" class="cursor-pointer signup-text ms-1">
          Sign up
        </a> -->
      </div>
    </div>
  </div>
</div>
